import React from 'react';
import { IconName } from '@ardoq/icons';
import { IconButton } from '@ardoq/button';
import styled from 'styled-components';
import { colors, r4 } from '@ardoq/design-tokens';
import { type I18nLocale, t } from '@ardoq/i18n';
import { CAPTURE_HIDE } from '@ardoq/export/captureMode';

const FullscreenButtonContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  background-color: ${colors.bgSubtle};
  border: 1px solid ${colors.bgSubtle};
  border-radius: ${r4};

  > button {
    background-color: ${colors.bgDefault};

    &:hover {
      background-color: ${colors.bgSubtle};
    }
  }
`;

const FullscreenButton = ({
  onClick,
  i18nLocale,
}: {
  onClick: VoidFunction;
  i18nLocale: I18nLocale;
}) => {
  return (
    <FullscreenButtonContainer
      className="show-only-on-hover"
      data-capture={CAPTURE_HIDE}
    >
      <IconButton
        label={t(
          i18nLocale,
          'dashboard:headerBar.expandWidget',
          'Expand widget'
        )}
        iconName={IconName.FULLSCREEN}
        onClick={onClick}
      />
    </FullscreenButtonContainer>
  );
};

export { FullscreenButton };
